
import { Component, Vue } from 'vue-property-decorator';
import Plot1 from '@/components/DataTab/Charts/Plot1.vue';
import Plot2 from '@/components/DataTab/Charts/Plot2.vue';
import Plot3 from '@/components/DataTab/Charts/Plot3.vue';
import Plot4 from '@/components/DataTab/Charts/Plot4.vue';
import Plot5 from '@/components/DataTab/Charts/Plot5.vue';
import Plot6 from '@/components/DataTab/Charts/Plot6.vue';
import Plot11 from '@/components/DataTab/Charts/Plot11.vue';
import Plot12 from '@/components/DataTab/Charts/Plot12.vue';
import Plot13 from '@/components/DataTab/Charts/Plot13.vue';
import Plot14 from '@/components/DataTab/Charts/Plot14.vue';
import Plot19 from '@/components/DataTab/Charts/Plot19.vue';
import Plot20 from '@/components/DataTab/Charts/Plot20.vue';
import Plot21 from '@/components/DataTab/Charts/Plot21.vue';
import Plot22 from '@/components/DataTab/Charts/Plot22.vue';
import Plot23 from '@/components/DataTab/Charts/Plot23.vue';
import Plot25 from '@/components/DataTab/Charts/Plot25.vue';
import Plot26 from '@/components/DataTab/Charts/Plot26.vue';
import Plot27 from '@/components/DataTab/Charts/Plot27.vue';
import Plot107 from '@/components/DataTab/Charts/Plot107.vue';
import Plot115 from '@/components/DataTab/Charts/Plot115.vue';
import Plot117 from '@/components/DataTab/Charts/Plot117.vue';

import DataTableOfContents from '@/components/DataTab/DataTableOfContents.vue';

import { AreaType, ScenarioType } from '@/types';

@Component({
  components: {
    DataTableOfContents,
  },
})
export default class DataTabChart extends Vue {
  charts = {
    1: Plot1,
    2: Plot2,
    3: Plot3,
    4: Plot4,
    5: Plot5,
    6: Plot6,
    11: Plot11,
    12: Plot12,
    13: Plot13,
    14: Plot14,
    19: Plot19,
    20: Plot20,
    21: Plot21,
    22: Plot22,
    23: Plot23,
    25: Plot25,
    26: Plot26,
    27: Plot27,
    107: Plot107, // charts 7 and 8
    115: Plot115, // charts 15 and 16
    117: Plot117, // charts 17 and 18
  };

  get selectedChart(): number | null {
    return this.$store.getters.selectedChart;
  }

  get chartComponent() {
    if (this.selectedChart) {
      //@ts-ignore
      return this.charts[this.selectedChart];
    } else return null;
  }
  get selectedArea(): AreaType | null {
    return this.$store.getters.selectedArea;
  }

  get selectedScenarios(): ScenarioType[] {
    return this.$store.getters.selectedScenarios;
  }
}
